import { Dial } from '../Dial';
import { MACROS, getPath } from './fieldSpec';
import type { DraftObject } from './EngineForm';

export function MacroDials({ draft, onChange }: { draft: DraftObject; onChange: (path: string, value: number) => void }) {
  return (
    <div className="row" role="group" aria-label="Macros" style={{ gap: 12 }}>
      {MACROS.map((m) => {
        const v = getPath(draft, `macros.${m}`);
        return <Dial key={m} label={m} value={typeof v === 'number' ? v : 0.5} onChange={(x) => onChange(`macros.${m}`, x)} />;
      })}
    </div>
  );
}
